// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n8-c";
export var backButton = "_n8-4";
export var backIcon = "_n8-5";
export var chevronShortcut = "_n8-6";
export var container = "_n8-1";
export var editor = "_n8-8";
export var editorWrapper = "_n8-7";
export var prefix = "_n8-2";
export var searchIcon = "_n8-3";
export var suffix = "_n8-9";
export var suffixContent = "_n8-a";
export var suffixText = "_n8-b";
export var wrapper = "_n8-0";